export interface EmailSuivi {
    id: number;
    actif: boolean;
    email: string;
}

export interface SuiviDI {
    actif: boolean;
    emailsSuivi: EmailSuivi[];
}

export interface OptionsSuiviInterventionState {
    isModaleOpen: boolean;
    isLoading: boolean;
    suiviDI : SuiviDI;
    newEmail: string,
}

export const initialState: OptionsSuiviInterventionState = {
    isModaleOpen: false,
    isLoading: false,
    suiviDI : {
        actif: true,
        emailsSuivi: [],
    },
    newEmail: '',
};

export const state: OptionsSuiviInterventionState = {
    ...initialState
};
